export default function BlogHero() {
  return (
    <section className="relative h-[420px] md:h-[500px] flex items-end overflow-hidden">
      <img
        src="/images/hero/welding.webp"
        alt="ISMAN Engineering Blog"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-teal-950/85 via-teal-900/50 to-cyan-900/25"></div>
      {/* Subtle teal glow bottom-left */}
      <div className="absolute bottom-0 left-0 w-[500px] h-[200px] pointer-events-none"
        style={{ background: "radial-gradient(ellipse at 0% 100%, rgba(20,184,166,0.25) 0%, transparent 65%)" }} />
      <div className="relative w-full max-w-7xl mx-auto px-6 pb-14">
        <span className="inline-block bg-teal-500/90 backdrop-blur-sm text-white text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-md mb-4">
          ISMAN Knowledge Hub
        </span>
        <h1 className="text-white text-4xl md:text-5xl font-bold leading-tight mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
          Engineering Insights &amp; Industry News
        </h1>
        <p className="text-cyan-100/90 text-base md:text-lg max-w-2xl">
          Expert articles on commercial kitchen design, HVAC, food processing, hospital equipment, and engineering standards in Kenya and East Africa.
        </p>
      </div>
    </section>
  );
}
